// extracted by mini-css-extract-plugin
module.exports = {"bottomBanner":"BottomBanner_bottomBanner__4W6jA","texts":"BottomBanner_texts__MGcxa"};